import copy from 'copy-to-clipboard'
import { Notification } from '@/components'
import { message } from 'antd'


const copyHandler = (content: string) => {
  copy(content)
  // message.success('复制成功')
  Notification.Success('复制成功')
}

export default copyHandler